'use strict';

var base = require('./base');
var Swiper = require('swiper/bundle'); // .default;// .esm.browser.bundle

const PhotoSwipeLightbox = require('photoswipe/lightbox').default;
const PhotoSwipe = require('photoswipe').default;

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

/**
 * function used to inititalize the find your swiper
 */
function initPdpImagesSlider() {
    // eslint-disable-next-line new-cap
    var swiperThumb = new Swiper.default('.pdp-thumbnail-swiper', {
        spaceBetween: 10,
        slidesPerView: 5,
        watchSlidesProgress: true,
        direction: 'vertical',
        clickable: true,
        freeMode: true,
        watchSlidesVisibility: true,
        threshold: 1000,
    });
    // eslint-disable-next-line new-cap, no-new, no-unused-vars
    var newPDPSwiper = new Swiper.default('.pdp-main-images-slider', {
        spaceBetween: 20,
        navigation: {
            nextEl: '.primary-images .swiper-button-next',
            prevEl: '.primary-images .swiper-button-prev',
        },
        thumbs: {
            swiper: swiperThumb,
        },
        pagination: {
            el: '.pdp-main-images-slider .swiper-pagination',
        },
    });
    $('body').on('keydown', '.pdp-images-slider-thumbnail img', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            newPDPSwiper.slideTo($(this).data('index'));
        }
    });
}

/**
 * Description
 * @param {string} cookieName - name of the cookie
 * @returns {any} sets cookie value
 */
function getCookie(cookieName) {
    let cookies = document.cookie;
    let cookieArray = cookies.split('; ');

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        let [name, value] = cookie.split('=');

        if (name === cookieName) {
            return decodeURIComponent(value);
        }
    }

    return 'false';
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements:
			updateAddToCartEnableDisableOtherElements,
    },
    initPdpImagesSlider: initPdpImagesSlider,
    zoomImage: function () {
        // $('.zoom').zoom({
        //     magnify: 2,
        //     touch: false,
        // });

        document.querySelectorAll('.pdp-images-slider a').forEach((anchor) => {
            const img = new Image();
            img.src = anchor.dataset.pswpSrc;
            img.onload = () => {
                anchor.setAttribute('data-pswp-width', img.naturalWidth);
                anchor.setAttribute('data-pswp-height', img.naturalHeight);
            };
        });

        const lightbox = new PhotoSwipeLightbox({
            gallery: '.pdp-images-slider',
            children: 'a',
            pswpModule: PhotoSwipe,
        });
        lightbox.init();

        const observer = new MutationObserver((mutationsList) => {
            let needsReinit = false;

            mutationsList.forEach((mutation) => {
                // Check if any new elements matching the gallery selector are added
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.matches('.tng')) {
                        needsReinit = true;
                    }
                });
            });

            // Reinitialize PhotoSwipeLightbox if new galleries are added
            if (needsReinit) {
                if (lightbox) {
                    lightbox.destroy();
                }
                // updating tng element to support light box structure
                var tngElement = $('.pdp-images-slider .swiper-slide.tng');
                var imageURL = tngElement.find('img').attr('src');
                var detachedElm = tngElement.find('span').detach();
                tngElement.append(
                    '<a data-pswp-src="' +
						imageURL +
						'" data-pswp-width="578" data-pswp-height="770" href="javascript:void(0)"></a>'
                );
                tngElement.find('a').append(detachedElm);
                const imageMap = [];

                // Traverse the images inside the #gallery
                $('.pdp-images-slider img').each(function () {
                    // Push image attributes into the map
                    imageMap.push({
                        src: $(this).attr('src'),
                        width: $(this).width(),
                        height: $(this).height(),
                    });
                });
                const lightbox1 = new PhotoSwipeLightbox({
                    gallery: '.pdp-images-slider',
                    children: 'a',
                    pswpModule: PhotoSwipe,
                    initialZoomLevel: 'fit',
                });

                lightbox1.on('uiRegister', function () {
                    // Add a click event listener to the PhotoSwipe background
                    lightbox1.pswp.element.addEventListener('click', function (e) {
                        // Check if the clicked element is the background
                        if (e.target.classList.contains('pswp__bg')) {
                            lightbox1.pswp.close(); // Close the PhotoSwipe instance
                        }
                    });
                });
                lightbox1.init();
            }
        });

        // Start observing for changes
        const targetNode = document.querySelector('.pdp-images-slider');
        const config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer
                .find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer
                    .find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer
                    .find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on(
            'product:beforeAddToCart product:beforeAttributeSelect',
            function () {
                $.spinner().start();
            }
        );
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data(
                    'pid',
                    response.data.product.id
                );
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                !response.product.readyToOrder || !response.product.available
            );

            var enable = $('.product-availability')
                .toArray()
                .every(function (item) {
                    return $(item).data('available') && $(item).data('ready-to-order');
                });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty()
                .html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(
                        allReady ? response.message : response.resources.info_selectforstock
                    );
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this)
                .closest('.size-chart')
                .find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    },
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (e) {
            e.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            navigator.clipboard.writeText($('#shareUrl').val());
            // document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    adaImageSupport: function () {
        $('body').on('keydown', '.pdp-images-slider-thumbnail img', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
        $('body').on(
            'keydown',
            '.specification .specification-toggle, .faq-list .faq-question',
            function (e) {
                if (e.keyCode === 13) {
                    $(this).trigger('click');
                }
            }
        );
    },
    accordianSupport: function () {
        $('.accordion-header').on('click', function () {
            const panelId = $(this).attr('aria-controls');
            const isExpanded = $(this).attr('aria-expanded') === 'true';

            // Collapse all other panels (accordion behavior)
            $('.accordion-header').attr('aria-expanded', 'false');
            $('.accordion-panel').slideUp(200).attr('hidden', true);

            // Expand the clicked panel if it was collapsed
            if (!isExpanded) {
                $(this).attr('aria-expanded', 'true');
                $('#' + panelId)
                    .slideDown(200)
                    .removeAttr('hidden');
            }
        });

        // Add keyboard accessibility (Up/Down arrow keys)
        $('.accordion-header').on('keydown', function (e) {
            const key = e.key;
            const headers = $('.accordion-header');
            let index = headers.index(this);

            if (key === 'ArrowDown') {
                index = (index + 1) % headers.length;
                headers.eq(index).focus();
            } else if (key === 'ArrowUp') {
                index = (index - 1 + headers.length) % headers.length;
                headers.eq(index).focus();
            }
        });
    },
    appendSalesRepToURL: function () {
        const urlParams = new URLSearchParams(window.location.search);
        const value = urlParams.get('rep');
        if (value !== null) {
            // If the URL already contains the 'rep' parameter, do nothing
        } else {
            var salesRep = getCookie('repCode');
            if (salesRep !== null && salesRep !== 'false') {
                // Append the salesRep value to the URL
                var url = new URL(window.location.href);
                url.searchParams.set('rep', salesRep);
                // Update the URL in the browser without reloading the page
                window.history.replaceState({}, '', url);
            }
        }
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
};
